import type { SourceFileRef } from "@checkone/contract/client";
import { SOURCE_LABEL, formatDateTime, formatDay, shaPrefix } from "../lib/format";

/** The evidence line for one FBR file: list, published date, then hash prefix and fetch time. */
export function FileRef({ file }: { file: SourceFileRef }) {
  return (
    <div className="file-ref">
      <span>
        <span className="src">{SOURCE_LABEL[file.source]}</span> · dated {formatDay(file.published_on)}
      </span>
      <span className="subtle">
        sha256{" "}
        <span className="mono" title={file.sha256}>
          {shaPrefix(file.sha256)}
        </span>{" "}
        · fetched {formatDateTime(file.fetched_at)}
      </span>
    </div>
  );
}
